export default {
  PARTIAL: 'PARTIAL',
  ENTIRE: 'ENTIRE',
};
